import { DrawerWrapper } from '@/components'
import useActiveManagementStore from '@/features/ActiveManagement/stores/useActiveManagementStore/useActiveManagementStore'
import { IntervalReportSettings, useElementWidth } from '@/hooks'
import * as React from 'react'
import { useCallback, useEffect, useState } from 'react'
import { useActiveManagementFiltersGetParams } from '../../hooks/useActiveManagementFiltersGetParams'
import { useActiveManagementFiltersStore } from '../../stores/useActiveManagementFiltersStore'
import { useActiveManagementHeaderSlot } from '../ActiveManagementHeaderSlot/useActiveManagementHeaderSlot'
import { IntervalDrawer } from '../IntervalDrawer/IntervalDrawer'
import { IntervalActions } from './IntervalActions/IntervalActions'
import { IntervalReport } from './IntervalReport'

export const Interval = () => {
    const [isOpen, setIsOpen] = useState(false)
    const toggleButtonRef = React.useRef<HTMLButtonElement>(null)
    const toggleWidth = useElementWidth(toggleButtonRef)
    const calculationMethodOffset = isOpen ? 16 : toggleWidth
    const { setSlot } = useActiveManagementHeaderSlot()
    const activeFilters = useActiveManagementFiltersStore(
        (state) => state.activeFilters
    )

    const reportSettings = useActiveManagementStore(
        (state) => state.intervalData.reportSettings
    )

    const setReportSettingsFromStore = useActiveManagementStore(
        (state) => state.intervalData.setReportSettings
    )

    const setReportSettings = useCallback(
        (newSettings: Partial<IntervalReportSettings>) => {
            const typeSetting: Partial<IntervalReportSettings> = {}

            if (newSettings.display) {
                typeSetting['type'] =
                    newSettings.display === 'meters'
                        ? 'utilityData'
                        : 'subMeterData'
            }

            setReportSettingsFromStore({
                ...reportSettings,
                ...newSettings,
                ...typeSetting,
            })
        },
        [reportSettings, setReportSettingsFromStore]
    )
    const processedFilters = useActiveManagementFiltersGetParams(
        activeFilters,
        reportSettings
    )

    useEffect(() => {
        setSlot(
            <IntervalActions
                filters={processedFilters}
                reportSettings={reportSettings}
            />
        )

        return () => {
            setSlot(null)
        }
    }, [processedFilters, reportSettings, setSlot])

    return (
        <DrawerWrapper>
            <IntervalDrawer
                reportSettings={reportSettings}
                setReportSettings={setReportSettings}
                activeFilters={activeFilters}
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                toggleButtonRef={toggleButtonRef}
            />
            <IntervalReport
                activeFilters={activeFilters}
                reportSettings={reportSettings}
                setReportSettings={setReportSettings}
                isOpen={isOpen}
                calculationMethodOffset={calculationMethodOffset}
            />
        </DrawerWrapper>
    )
}
